import { HttpClient } from '@angular/common/http';
import {
  makeStateKey,
  StateKey,
  TransferState,
} from '@angular/platform-browser';

import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  DEFAULT_TRANSLATE_PREFIX,
  DEFAULT_TRANSLATE_SUFFIX,
} from '@app/core/constants/translate';

export class TranslateBrowserLoader implements TranslateLoader {
  private readonly defaultPrefix = DEFAULT_TRANSLATE_PREFIX;
  private readonly defaultSuffix = DEFAULT_TRANSLATE_SUFFIX;

  constructor(private http: HttpClient, private transferState: TransferState) {}

  public getTranslation(lang: string): Observable<any> {
    const key: StateKey<number> = makeStateKey<number>(
      'transfer-translate-' + lang,
    );
    const data = this.transferState.get(key, null);
    if (data) {
      return new Observable(observer => {
        observer.next(data);
        observer.complete();
      });
    } else {
      const prefix = this.defaultPrefix;
      const suffix = this.defaultSuffix;
      return new TranslateHttpLoader(this.http, prefix, suffix + Date.now())
        .getTranslation(lang)
        .pipe(
          catchError(() =>
            new TranslateHttpLoader(
              this.http,
              this.defaultPrefix,
              this.defaultSuffix + Date.now(),
            ).getTranslation(lang),
          ),
        );
    }
  }
}

export function translateBrowserLoaderFactory(
  httpClient: HttpClient,
  transferState: TransferState,
): any {
  return new TranslateBrowserLoader(httpClient, transferState);
}
